import React, { useState, useContext, useEffect, useLayoutEffect, useRef, useMemo } from 'react';
import StudentNav from '../Navbars/StudentNav';
import AdminNav from '../Navbars/AdminNav';
import TeacherNav from '../Navbars/TeacherNav';
import GuestNav from '../Navbars/GuestNav';
import Footer from '../Footer';
import { useParams } from 'react-router-dom';
import './CreateCertificate.css';
import { UserContext } from '../UserContext';
import { useNavigate } from 'react-router-dom/dist/umd/react-router-dom.development';
import axios from 'axios';

import { PDFDownloadLink } from "@react-pdf/renderer";
import { Margin, usePDF, Resolution } from 'react-to-pdf';

import PDF from './PDF';
import Signature from "./PDF_Images/signature.png";
import Select from 'react-select';
import cLogo from "./PDF_Images/certificate-logo.png";

import LebronStretch from "./PDF_Images/Image1.jpeg";

import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import * as XLSX from 'xlsx';

const highlightText = (text, highlight) => {
  if (!highlight || !highlight.trim()) return text;
  const regex = new RegExp(`(${highlight})`, "gi");
  const parts = (text || "").toString().split(regex);
  return parts.map((part, i) =>
    regex.test(part) ? (
      <span key={i} style={{ backgroundColor: "#ffff00", fontWeight: "bold" }}>
        {part}
      </span>
    ) : (
      part
    )
  );
};



const CreateCertificate2 = () => {
  const [loading, setLoading] = useState(false);
  const [invoices, setInvoices] = useState([]);
  const [filteredInvoices, setFilteredInvoices] = useState([]);
  const { courseId, coursename } = useParams();
  const [filterCompetition, setFilterCompetition] = useState("All");
  const [competitions, setCompetitions] = useState([]);
  const [filterAgeGroup, setFilterAgeGroup] = useState("All");
  const [ageGroups, setAgeGroups] = useState([]);
  // const [courseName, setCourseName] = useState('');
  const [students, setStudents] = useState([]);
  const [selectedStudentDetails, setSelectedStudentDetails] = useState(null);
  const [certificateNumber, setCertificateNumber] = useState(Math.floor(Math.random() * 9000) + 1000)
  const [courses, setCourses] = useState([])
  const [selectedCourse, setSelectedCourse] = useState({ courseId: '', coursename: '' })
  const [refresh, setRefresh] = useState(false)
  const [competition, setCompetition] = useState([])
  const [emailSingleLoading, setEmailSingleLoading] = useState({});
  const [showInvoices, setShowInvoices] = useState(false);
  const [selectedCompetition, setSelectedCompetition] = useState("");
  const [selectedCompetitionName, setSelectedCompetitionName] = useState('');
  const [searchTerm, setSearchTerm] = useState("");
  const [studentSearchTerm, setStudentSearchTerm] = useState("");
  const [isGeneratingSingle, setIsGeneratingSingle] = useState(false);
  const [isUploading, setIsUploading] = useState(false);
  const [isDownloadingAll, setIsDownloadingAll] = useState(false);
  const [shouldCancelDownload, setShouldCancelDownload] = useState(false);
  const [downloadProgress, setDownloadProgress] = useState({ current: 0, total: 0 });
  const [winnersLimit, setWinnersLimit] = useState(3);
  const fileInputRef = useRef(null);
  const cancelDownloadRef = useRef(false);

  const filteredAgeGroups = useMemo(() => {
    if (filterCompetition === "All") return ageGroups; // show all if no competition selected
    return ageGroups.filter(ag => ag.Competition_Id == filterCompetition);
  }, [ageGroups, filterCompetition]);

  useEffect(() => {
    const fetchAgeGroups = async () => {
      try {
        const res = await axios.get(
          `${(process.env.REACT_APP_API_BASE_URL || process.env.REACT_APP_LOCAL_SERVER_API)}/polymatcAgeGroup`
        );
        setAgeGroups(res.data.data || []);
      } catch (err) {
        console.error("Failed to fetch age groups", err);
      }
    };

    fetchAgeGroups();
  }, []);

  useEffect(() => {
    let data = [...invoices];

    // 🔹 Competition filter
    if (filterCompetition !== "All") {
      data = data.filter(
        inv => inv.Competition_Id == filterCompetition
      );
    }

    // 🔹 Age Group filter
    if (filterAgeGroup !== "All") {
      data = data.filter(
        inv => inv.Agegroup_Id == filterAgeGroup
      );
    }

    // 🔹 Search filter
    if (searchTerm.trim() !== "") {
      const lowerSearch = searchTerm.toLowerCase();
      data = data.filter(inv => {
        const compName = competition?.find(c => c.Competition_Id === inv.Competition_Id)?.Competition_Name || "";
        const fullName = `${inv.First_name || ""} ${inv.Last_name || ""}`.toLowerCase();
        return (
          fullName.includes(lowerSearch) ||
          (inv.Contact_Num && inv.Contact_Num.toLowerCase().includes(lowerSearch)) ||
          (inv.Email && inv.Email.toLowerCase().includes(lowerSearch)) ||
          (inv.Parent_name && inv.Parent_name.toLowerCase().includes(lowerSearch)) ||
          (inv.Country && inv.Country.toLowerCase().includes(lowerSearch)) ||
          (compName && compName.toLowerCase().includes(lowerSearch)) ||
          (inv.Age && inv.Age.toString().includes(lowerSearch)) ||
          (inv.Rank && inv.Rank.toString().includes(lowerSearch)) ||
          (inv.Total && inv.Total.toString().includes(lowerSearch)) ||
          (inv.Username && inv.Username.toLowerCase().includes(lowerSearch)) ||
          (inv.Participant_id && inv.Participant_id.toString().includes(lowerSearch)) ||
          ((inv.reg_Age || inv.Age) && (inv.reg_Age || inv.Age).toString().includes(lowerSearch))
        );
      });
    }

    setFilteredInvoices(data);
  }, [invoices, filterCompetition, filterAgeGroup, searchTerm, competition]);


  const getRankIcon = (rank) => {
    if (rank === 1 || rank === 2 || rank === 3) {
      return <span className="rank-trophy">🏆</span>;
    }
    if (rank === 4 || rank === 5) {
      return <span className="rank-medal">🏅</span>;
    }
    return null; // 6th rank ke baad kuch show nahi hoga
  };

  const fetchPolymatchResults = async () => {
    setLoading(true);
    try {
      const response = await axios.get(`${(process.env.REACT_APP_API_BASE_URL || process.env.REACT_APP_LOCAL_SERVER_API)}/polymatch-results`);
      const data = response.data || [];
      setInvoices(data); // store in invoices
    } catch (error) {
      console.error("Error fetching polymatch results:", error);
    } finally {
      setLoading(false);
    }
  };

  const handleLoadAll = () => {
    setShowInvoices(true);
    fetchPolymatchResults();
  };

  const handleCloseInvoices = () => {
    setShowInvoices(false);
    setInvoices([]);
  };

  const handleCompetitionChangeFilter = (e) => {
    const value = e.target.value;
    setFilterCompetition(value);
    if (value !== "All") {
      setShowInvoices(true);
    }
  };

  const handleSearchChange = (e) => {
    const value = e.target.value;
    setSearchTerm(value);
    if (value.trim() !== "") {
      setShowInvoices(true);
    }
  };

  const handleAgeGroupChangeFilter = (e) => {
    const value = e.target.value;
    setFilterAgeGroup(value);
    if (value !== "All") {
      setShowInvoices(true);
    }
  };

  useEffect(() => {
    if (showInvoices) {
      fetchPolymatchResults();
    }
  }, [showInvoices]);


  // polymatchcompetitions
  async function getCurrentDateTime() {
    const now = new Date();

    // Extract date components
    const year = now.getFullYear();
    const month = String(now.getMonth() + 1).padStart(2, '0'); // Months are 0-indexed
    const day = String(now.getDate()).padStart(2, '0');

    // Extract time components
    const hours = String(now.getHours()).padStart(2, '0');
    const minutes = String(now.getMinutes()).padStart(2, '0');
    const seconds = String(now.getSeconds()).padStart(2, '0');

    // Concatenate all components without spaces, dashes, or colons
    return `${year}${month}${day}${hours}${minutes}${seconds}`;
  }

  useEffect(() => {

    // fetchCourseName();
    fetchStudents();
    fetchCertificatNumber()

  }, [refresh]);
  const fetchCertificatNumber = async () => {
    // getCertificateCourses
    // axios.get(`${(process.env.REACT_APP_API_BASE_URL || process.env.REACT_APP_LOCAL_SERVER_API)}/generateEventCertificateNumber`).then((res) => {

    // })
    setCertificateNumber(((selectedStudentDetails?.cid)?.toString() || 1) + await getCurrentDateTime())

  }



  const fetchCourseName = async () => {
    try {
    } catch (error) {
      console.error('Error fetching course name:', error);
    }
  };
  const fetchStudents = async () => {
    if (!selectedCompetition) {
      setStudents([]);
      return;
    }
    try {
      const response = await axios.get(`${(process.env.REACT_APP_API_BASE_URL || process.env.REACT_APP_LOCAL_SERVER_API)}/student_certificate/${selectedCompetition}`);
      setStudents(response.data);
      if (response.data.length > 0) {
        setCertificateNumber(((response.data[0].cid)?.toString() || 1) + await getCurrentDateTime())
      }
    } catch (error) {
      console.error('Error fetching students:', error);
    }
  };
  const fetchCompetition = async () => {
    // if (courseId) {
    try {
      const response = await axios.get(`${(process.env.REACT_APP_API_BASE_URL || process.env.REACT_APP_LOCAL_SERVER_API)}/allpolymatchcompetition`);
      setCompetition(response.data);
    } catch (error) {
      console.error('Error fetching students:', error);
    }
  };

  const formatDate = (dateStr) => {
    const date = new Date(dateStr);
    const day = date.getDate()?.toString().padStart(2, '0');
    const month = (date.getMonth() + 1)?.toString().padStart(2, '0');
    const year = date.getFullYear();
    return `${day}-${month}-${year}`;
  };
  // Handle student selection
  const handleStudentChange = async (event) => {
    const studentEmail = event.target.value;
    const selectedStudent = students.find(student => student.email === studentEmail);
    setCertificateNumber((selectedStudent?.cid)?.toString() + await getCurrentDateTime())

    // Find Age Group Display Name
    const ageGroup = ageGroups.find(ag => ag.Agegroup_Id === selectedStudent?.Agegroup_Id);
    const ageDisplay = ageGroup?.Display_Name || selectedStudent?.reg_Age || selectedStudent?.Age || "";

    setSelectedStudentDetails(selectedStudent ? {
      // userId: selectedStudent.User_id,
      id: selectedStudent.id,
      firstname: selectedStudent.student_name,
      lastname: selectedStudent.lastname,
      parentname: selectedStudent.parent_name,
      email: selectedStudent.email,
      cid: selectedStudent.cid,
      c_name: selectedStudent.name,
      c_date: selectedStudent.c_date,
      age: ageDisplay, // Add Age/Category
      Agegroup_Id: selectedStudent.Agegroup_Id
    } : null);
  };



  const { isAdmin, isTeacher, isStudent, isGuest, setUserRole, setUserInfo, userInfo } = useContext(UserContext);
  useLayoutEffect(() => {
    const fetchData = async () => {
      await fetch(`${(process.env.REACT_APP_API_BASE_URL || process.env.REACT_APP_LOCAL_SERVER_API)}`, {
        credentials: 'include',
      }).then(response => {
        //  console.log("Response:",response);
        response.json().then(userInfo => {
          //  console.log("userinfo:",userInfo);
          setUserInfo(userInfo);
          if (userInfo?.usertype) {
            const uType = userInfo?.usertype;
            setUserRole(uType);
          }
          const uname = userInfo?.username;
          const avatar = userInfo?.avatar; // Store the avatar in a separate variable


        })
          .catch(err => console.log("Error in useeffect:", err))
      });
    }
    fetchData();
    fetchCompetition()
  }, [isAdmin, isTeacher, isStudent, isGuest]);

  const onLogin = (usertype) => {

    setUserRole(usertype);
  };
  const navigate = useNavigate();

  async function onLogout() {
    await fetch(`${(process.env.REACT_APP_API_BASE_URL || process.env.REACT_APP_LOCAL_SERVER_API)}/logout`, {
      credentials: 'include',
      method: 'POST',
    });
    setUserInfo(null);
    console.log("navigating");
    navigate('/');
    // console.log("navigated");
    setUserRole('guest');
  }
  const options = {
    method: 'open',

    page: {
      format: 'A2',
      orientation: 'landscape',
    }
  }
  const username = userInfo?.username;
  const _avatar_ = userInfo?.avatar;
  const dynamicFilename = `certificate-${selectedStudentDetails?.firstname}-${selectedStudentDetails?.id}.pdf`;
  console.log("selectedStudentDetails?.firstname", selectedStudentDetails?.firstname)
  const { toPDF, targetRef } = usePDF({
    filename: `certificate-${selectedStudentDetails?.firstname} ${selectedStudentDetails?.lastname}-${selectedStudentDetails?.id}.pdf`,
    // paperSize: [1600, 1234],
    // format: '1600x1234',
    // paperSize: [1234, 1600], // Swap width and height for landscape
    // format: '1234x1600',     // Ensure the format matches the landscape dimensions
    paperSize: [1234, 1600], // Explicitly set width < height for landscape
    format: 'landscape',    // Check if the library supports an orientation property
    page: { margin: Margin.NONE, orientation: "landscape" },
    resolution: Resolution.LOW

  });
  // async function generateCertificatePdf() {

  //   const pdf = await toPDF();
  //   const pdfBlob = pdf.output('blob');
  //   const formDataInvoice = new FormData();
  //   const data = {
  //     id: selectedStudentDetails.id,
  //     name: selectedStudentDetails.firstname,
  //     email: selectedStudentDetails.email,
  //     certificate_no: certificateNumber
  //   }

  //   formDataInvoice.append('pdfFile', pdfBlob, `Certificate-${certificateNumber}.pdf`);
  //   formDataInvoice.append('data', JSON.stringify(data));

  //   const response = await axios.post(`${(process.env.REACT_APP_API_BASE_URL || process.env.REACT_APP_LOCAL_SERVER_API)}/generateCertificateEvent`, formDataInvoice, {
  //     headers: {
  //       'Content-Type': 'multipart/form-data',
  //     }
  //   }).then(() => {
  //     setStudents([])
  //     setSelectedStudentDetails(null)
  //     setCourses([])
  //     setRefresh(!refresh)
  //   })

  // }
  function getDate() {
    const now = new Date();
    const date = now.getDate();

    const monthName = now.toLocaleString('en-US', { month: 'short' });
    const year = now.getFullYear();
    return `${date}-${monthName}-${year}`;
    // return today.toDateString().slice(0, 10)
  }
  const [currentDate, setCurrentDate] = useState(getDate());
  const [textAreaValue, setTeaxtAreaValue] = useState(`for Participation in Mental Math Competition - PolyMatch `)
  const [certificateType, setCertificateType] = useState(2)

  // Helper to get year from selected competition
  const getSelectedCompetitionYear = () => {
    if (!selectedCompetition) return new Date().getFullYear();
    const comp = competition?.find(c => c.Competition_Id.toString() === selectedCompetition.toString());
    return comp ? new Date(comp.Competition_date).getFullYear() : new Date().getFullYear();
  };

  // Helper to get ordinal suffix for rank
  const getOrdinal = (n) => {
    const s = ["th", "st", "nd", "rd"];
    const v = n % 100;
    return n + (s[(v - 20) % 10] || s[v] || s[0]);
  };

  function chageCertificateType(e) {
    const newType = e.target.value;
    setCertificateType(newType);

    const year = getSelectedCompetitionYear();

    if (newType == 3) {
      const rankText = selectedStudentDetails?.Rank ? `for ${getOrdinal(selectedStudentDetails.Rank)} position` : "Winner";
      setTeaxtAreaValue(`${rankText} in PolyMatch ${selectedCompetitionName} ${year}`);
    } else if (newType == 2) {
      setTeaxtAreaValue(`for participation in PolyMatch ${selectedCompetitionName} ${year}`);
    }
  }
  function handleCourseChange(e) {
    setSelectedCourse({ courseId: e.target.value, coursename: e.target[e.target.selectedIndex].label })
    setTeaxtAreaValue(`For the exceptional performance that has led to the successful completion of Polymath-Kids ${e.target[e.target.selectedIndex].label}  conducted between December 2022 and March 2023`)
  }
  async function makeCertificate(student, c_number) {
    const dynamicFilename = `certificate-${selectedStudentDetails?.firstname} ${selectedStudentDetails?.lastname}-${selectedStudentDetails?.id}.pdf`;

    const pdf = await toPDF();
    const pdfBlob = pdf.output('blob');

    const formDataInvoice = new FormData();
    const data = {
      id: student.id,
      name: student.student_name,
      lastname: student?.lastname || "",
      email: student.email,
      certificate_no: c_number
    };

    console.log('=== makeCertificate Payload ===', data);

    formDataInvoice.append('pdfFile', pdfBlob, dynamicFilename);
    // formDataInvoice.append('pdfFile', pdfBlob, `Certificate-${selectedStudentDetails?.firstname}-${certificateNumber}.pdf`);

    formDataInvoice.append('data', JSON.stringify(data));

    try {
      await axios.post(`${(process.env.REACT_APP_API_BASE_URL || process.env.REACT_APP_LOCAL_SERVER_API)}/generateCertificateEvent`, formDataInvoice, {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      });
      console.log(`Certificate for ${student.student_name} downloaded.`);
      return true;
    } catch (error) {
      console.error(`Error downloading certificate for ${student.student_name}:`, error);
      throw error;
    }
  }
  function delay(ms) {
    return new Promise(resolve => setTimeout(resolve, ms));
  }
  async function downloadSingleCertificate() {
    if (!selectedStudentDetails) {
      toast.error("Please select a student first!");
      return;
    }

    setIsGeneratingSingle(true);
    try {
      const student = students.find(s => s.id === selectedStudentDetails.id);
      if (student) {
        const c_number = (student?.cid)?.toString() + await getCurrentDateTime();
        setCertificateNumber(c_number);
        await delay(1000); // Small delay to ensure state update
        await makeCertificate(student, c_number);
        toast.success(`Certificate for ${student.student_name} generated!`);
        // Refresh data
        fetchPolymatchResults();
        fetchStudents();
      }
    } catch (error) {
      console.error("Error generating single certificate:", error);
      toast.error(error.response?.data?.message || "Error generating certificate.");
    } finally {
      setIsGeneratingSingle(false);
    }
  }

  async function downloadAllCertificates() {
    if (students.length === 0) {
      alert("No students available to download certificates for.");
      return;
    }

    // Initialize download state
    setIsDownloadingAll(true);
    setShouldCancelDownload(false);
    cancelDownloadRef.current = false;

    // Filter students if Winner Certificate is selected
    let studentsToDownload = students;
    if (certificateType == 3) {
      studentsToDownload = students.filter(s => s.Rank && s.Rank <= winnersLimit);
      if (studentsToDownload.length === 0) {
        toast.info(`No students found with Rank 1 to ${winnersLimit}.`);
        setIsDownloadingAll(false);
        return;
      }
    }

    setDownloadProgress({ current: 0, total: studentsToDownload.length });

    let downloadedCount = 0;
    let cancelled = false;

    for (let i = 0; i < studentsToDownload.length; i++) {
      // Check if user requested cancellation (use ref to avoid stale closure)
      if (cancelDownloadRef.current) {
        cancelled = true;
        break;
      }

      const student = studentsToDownload[i];
      console.log("selectedStudent :", student);

      const c_number = (student?.cid)?.toString() + await getCurrentDateTime();
      setCertificateNumber(c_number);

      // Find Age Group for Bulk
      const ageGroup = ageGroups.find(ag => ag.Agegroup_Id === student?.Agegroup_Id);
      const ageDisplay = ageGroup?.Display_Name || student?.reg_Age || student?.Age || "";

      setSelectedStudentDetails(student ? {
        id: student.id,
        firstname: student.student_name,
        lastname: student.lastname,
        parentname: student.parent_name,
        email: student.email,
        cid: student.cid,
        c_name: student.name,
        c_date: student.c_date,
        age: ageDisplay
      } : null);

      // Update progress
      downloadedCount++;
      setDownloadProgress({ current: downloadedCount, total: students.length });

      await delay(3000);
      try {
        await makeCertificate(student, c_number);
      } catch (error) {
        console.error(`Failed to download certificate for ${student.student_name}`);
      }
    }

    // Reset states
    setIsDownloadingAll(false);
    setShouldCancelDownload(false);
    setDownloadProgress({ current: 0, total: 0 });

    // Refresh data
    fetchPolymatchResults();
    fetchStudents();

    // Show appropriate message
    if (cancelled) {
      toast.warning(`Download cancelled. ${downloadedCount} of ${students.length} certificates were downloaded.`, {
        position: "top-center",
        autoClose: 3000,
      });
    } else {
      toast.success('All certificates have been downloaded!', {
        position: "top-center",
        autoClose: 3000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
      });
    }
  }
  async function emailAllCertificates() {
    if (!selectedCompetition) {
      toast.error("Please select a competition first!");
      return;
    }

    const toastId = toast.loading("Sending emails to all students...");
    try {
      const response = await axios.post(`${(process.env.REACT_APP_API_BASE_URL || process.env.REACT_APP_LOCAL_SERVER_API)}/sentCertificateEventBulk/${selectedCompetition}`);

      if (response.data.success) {
        toast.update(toastId, {
          render: response.data.message || "Emails sent successfully!",
          type: "success",
          isLoading: false,
          autoClose: 3000
        });
      } else {
        toast.update(toastId, {
          render: response.data.message || "Failed to send emails.",
          type: "error",
          isLoading: false,
          autoClose: 3000
        });
      }
    } catch (error) {
      console.error(`Error Sending Email certificates:`, error);
      toast.update(toastId, {
        render: error.response?.data?.message || "An error occurred while sending emails.",
        type: "error",
        isLoading: false,
        autoClose: 3000
      });
    }
  }

  const emailSingleCertificate = async (resultId) => {
    if (emailSingleLoading[resultId]) return;

    try {
      setEmailSingleLoading(prev => ({ ...prev, [resultId]: true }));
      const response = await axios.post(`${(process.env.REACT_APP_API_BASE_URL || process.env.REACT_APP_LOCAL_SERVER_API)}/sentCertificateEventSingle/${resultId}`);

      if (response.data.success) {
        toast.success(response.data.message);
        // Optional: Refresh results to show updated status if needed
        // setRefresh(prev => !prev);
      } else {
        toast.error(response.data.message || "Failed to send email");
      }
    } catch (error) {
      console.error(`Error Sending Single Certificate Email:`, error);
      toast.error(error.response?.data?.message || "Failed to send email. Please try again later.");
    } finally {
      setEmailSingleLoading(prev => ({ ...prev, [resultId]: false }));
    }
  };

  const handleStopDownload = () => {
    cancelDownloadRef.current = true;
    setShouldCancelDownload(true);
    toast.info("Stopping download process...");
  };

  const handleExcelUpload = (e) => {
    const file = e.target.files[0];
    if (!file) return;

    // Reset input so the same file can be uploaded again
    e.target.value = null;

    const reader = new FileReader();
    reader.onload = async (evt) => {
      try {
        setIsUploading(true);
        const bstr = evt.target.result;
        const wb = XLSX.read(bstr, { type: 'binary' });
        const wsname = wb.SheetNames[0];
        const ws = wb.Sheets[wsname];

        // Convert to array of arrays to find header row
        const rawData = XLSX.utils.sheet_to_json(ws, { header: 1 });

        let headerRowIndex = 0;
        let headers = [];

        // Find header row (look for "Rank" and "Player" or "Participant_id")
        for (let i = 0; i < Math.min(rawData.length, 20); i++) {
          const row = rawData[i];
          // Check for critical columns
          if (row.some(cell => cell && typeof cell === 'string' && (cell.toLowerCase().includes('rank') || cell.toLowerCase().includes('player') || cell.toLowerCase().includes('participant_id')))) {
            headerRowIndex = i;
            headers = row.map(h => (h ? h.toString().trim() : ""));
            break;
          }
        }

        // Parse data starting from the row after headers
        // We create a custom mapping logic
        const formattedData = [];

        // Helper to find column index by almost-matching name
        const findCol = (keywords) => {
          // Exact match priority
          const exactIdx = headers.findIndex(h => keywords.some(k => h.toLowerCase() === k.toLowerCase()));
          if (exactIdx !== -1) return exactIdx;

          // Almost match fallback
          return headers.findIndex(h => keywords.some(k => h.toLowerCase().includes(k.toLowerCase())));
        };

        const idxRank = findCol(['Rank']);
        const idxPlayer = findCol(['Username']);
        const idxId = findCol(['Participant_id', 'Participant ID']); // Participant_id not in sample but kept for internal use
        const idxTotal = findCol(['Total Score', 'Total']);
        const idxCorrect = findCol(['Correct Answers', 'C_ans']);
        const idxIncorrect = findCol(['Incorrect Answers', 'Incorrect_ans']);
        const idxCompId = findCol(['Competition_Id', 'Comp_id']);

        console.log("Excel Headers Detected:", {
          Rank: idxRank,
          Username: idxPlayer,
          Participant_id: idxId,
          Total: idxTotal,
          Correct: idxCorrect,
          Incorrect: idxIncorrect,
          Competition_Id: idxCompId
        });

        if (idxRank === -1 && idxId === -1 && idxPlayer === -1) {
          toast.error("Could not find required columns (Rank, Username/Player, or ID) in the first 20 rows.");
          setIsUploading(false);
          return;
        }

        for (let i = headerRowIndex + 1; i < rawData.length; i++) {
          const row = rawData[i];
          if (!row || row.length === 0) continue;

          let pId = null;
          let pUsername = null;

          // Strategy 1: Direct ID column
          if (idxId !== -1 && row[idxId]) {
            pId = row[idxId];
          }

          // Strategy 2: Direct Username column
          if (idxPlayer !== -1 && row[idxPlayer]) {
            pUsername = row[idxPlayer].toString().trim();
          }

          if (pId || pUsername) {
            const record = {
              Rank: idxRank !== -1 ? row[idxRank] : 0,
              Total: idxTotal !== -1 ? row[idxTotal] : 0,
              C_ans: idxCorrect !== -1 ? row[idxCorrect] : 0,
              Incorrect_ans: idxIncorrect !== -1 ? row[idxIncorrect] : 0
            };
            if (pId) record.Participant_id = pId;
            if (pUsername) record.Username = pUsername.trim(); // Trim username here

            // Priority: Row-specific Comp ID > Selected Competition from dropdown
            if (idxCompId !== -1 && row[idxCompId]) {
              record.Competition_Id = row[idxCompId];
            } else if (selectedCompetition) {
              record.Competition_Id = selectedCompetition;
            }

            formattedData.push(record);
          }
        }

        if (formattedData.length === 0) {
          console.error("DEBUG: No valid student data found");
          console.log("DEBUG: Headers found:", headers);
          console.log("DEBUG: Raw data rows:", rawData.length);
          console.log("DEBUG: Header row index:", headerRowIndex);
          toast.error("No valid student data found in the sheet.");
          setIsUploading(false);
          return;
        }

        console.log("DEBUG: Formatted data to send:", formattedData);

        // Send to backend
        const uploadResults = async (data, force = false) => {
          const response = await axios.post(`${(process.env.REACT_APP_API_BASE_URL || process.env.REACT_APP_LOCAL_SERVER_API)}/polymatch-results/bulk-upload`, {
            results: data,
            forceUpdate: force,
            defaultCompetitionId: selectedCompetition // Pass selected competition as fallback
          });

          if (response.data.duplicatesFound) {
            const studentNames = response.data.duplicates.map(d => `${d.name} (${d.username})`).join("\n");
            const confirmUpdate = window.confirm(
              `Some students already have results for this competition:\n\n${studentNames}\n\nDo you want to update their records with the new data?`
            );

            if (confirmUpdate) {
              return await uploadResults(data, true);
            } else {
              toast.info("Upload cancelled by user.");
              return null;
            }
          }
          return response.data;
        };

        const resultData = await uploadResults(formattedData);
        if (!resultData) {
          setIsUploading(false);
          return;
        }

        const { message, affectedRows, detectedCompetitionId } = resultData;

        let successMsg = `Successfully processed ${formattedData.length} records!`;

        if (detectedCompetitionId) {
          setFilterCompetition(detectedCompetitionId);
          setShowInvoices(true);

          // Find competition name for better feedback
          const compObj = competition?.find(c => c.Competition_Id == detectedCompetitionId);
          if (compObj) {
            successMsg += ` (Competition: ${compObj.Competition_Name})`;
          }
        }

        toast.success(successMsg);

        // Refresh the results table
        const resTable = await axios.get(`${(process.env.REACT_APP_API_BASE_URL || process.env.REACT_APP_LOCAL_SERVER_API)}/polymatch-results`);
        setInvoices(resTable.data || []);

      } catch (err) {
        console.error("Excel upload error:", err);
        toast.error("Failed to process Excel file. Please check the format.");
      } finally {
        setIsUploading(false);
      }
    };
    reader.readAsBinaryString(file);
  };

  const handleCompetitionChange = (e) => {
    const competitionId = e.target.value;
    setSelectedCompetition(competitionId);

    if (!competitionId) {
      setStudents([]);
      setSelectedStudentDetails(null);
      setSelectedCompetitionName("");
      setTeaxtAreaValue("");
      return;
    }

    // Find the selected competition and store its name
    const selectedComp = competition?.find(comp => comp.Competition_Id.toString() === competitionId);
    setSelectedCompetitionName(selectedComp?.Competition_Name || '');
    const year = selectedComp ? new Date(selectedComp.Competition_date).getFullYear() : new Date().getFullYear();

    // Clear previous student details as they belong to another competition
    setSelectedStudentDetails(null);

    // Update the text area value with the dynamic competition name
    if (certificateType === 3) {
      const rankText = "Winner"; // No rank yet as student is cleared
      setTeaxtAreaValue(`${rankText} in PolyMatch ${selectedComp?.Competition_Name || ''} ${year}`);
    } else {
      setTeaxtAreaValue(`for participation in PolyMatch ${selectedComp?.Competition_Name || ''} ${year}`);
    }
  };

  const downloadSampleExcel = () => {
    const headers = [
      "Rank",
      "Username",
      "Total Score",
      "Correct Answers",
      "Incorrect Answers",
      "Competition_Id"
    ];

    const sampleData = [
      {
        "Rank": 1,
        "Username": "john_doe",
        "Total Score": 95,
        "Correct Answers": 19,
        "Incorrect Answers": 1,
        "Competition_Id": 101
      }
    ];

    const ws = XLSX.utils.json_to_sheet(sampleData, { header: headers });
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, "Sample_Results");
    XLSX.writeFile(wb, "sample_results_format.xlsx");
  };
  useEffect(() => {
    fetchStudents()
  }, [selectedCompetition])

  return (
    <>

      {username && (
        <>
          {isAdmin && <AdminNav username={username} avatar={_avatar_} onLogout={onLogout} />}
          {isTeacher && <TeacherNav username={username} avatar={_avatar_} onLogout={onLogout} />}
          {isStudent && <StudentNav username={username} avatar={_avatar_} onLogout={onLogout} />}
        </>
      )}
      {!username && (
        <>
          {isGuest && <GuestNav onLogin={onLogin} />}
        </>
      )}

      <div className='edit-bar'>
        <h3 className='HeadingPDFcert'>
          Generate Certificate
        </h3>
        <br />
        <h2 className='coursenamePDFcert'>
          {selectedCourse.coursename}
        </h2>
      </div>


      {/* {students.length > 0 && (
        <div className='TeacherFilterSection'>
          <div className='TeacherFilter'>
            <select id='TPcourseDropdown' onChange={handleStudentChange}>
              <option value=''>Select Student</option>
              {students.map((student, index) => (
                <option key={index} value={student.email}>
                  {student.student_name}
                </option>
              ))}
            </select>
          </div>
        </div>
      )} */}

      <div className='TeacherFilterSection'>
        <div className='TeacherFilter'>
          <select id='TPcourseDropdown' onChange={handleCompetitionChange}>
            <option value='' >Select Competition</option>
            {competition && competition?.map((comp, index) => (
              <option key={index} value={comp.Competition_Id}>
                {comp.Competition_Name} ({new Date(comp.Competition_date).getFullYear()})
              </option>
            ))}
          </select>
        </div>
      </div>


      <div className='StudentDetails'>
        <h3>Student Details</h3>

        <table className='StudentTable'>
          <tbody>
            <tr>
              <th>Student Name</th>
              <td>
                <Select
                  className="student-select-container"
                  classNamePrefix="student-select"
                  placeholder={selectedCompetition ? "Type to search or select student..." : "Select a competition first..."}
                  isDisabled={!selectedCompetition}
                  options={students
                    .sort((a, b) => a.student_name.localeCompare(b.student_name))
                    .map(student => ({
                      value: student.email,
                      label: `${student.student_name} ${student.lastname || ''} (${student.email.split('@')[0]})`,
                      student: student
                    }))
                  }
                  isSearchable={true}
                  value={selectedStudentDetails ? {
                    value: selectedStudentDetails.email,
                    label: `${selectedStudentDetails.firstname} ${selectedStudentDetails.lastname || ''}`
                  } : null}
                  onChange={async (selectedOption) => {
                    if (selectedOption) {
                      const student = selectedOption.student;
                      setCertificateNumber((student?.cid)?.toString() + await getCurrentDateTime());
                      setSelectedStudentDetails({
                        id: student.id,
                        firstname: student.student_name,
                        lastname: student.lastname,
                        parentname: student.parent_name,
                        email: student.email,
                        cid: student.cid,
                        c_name: student.name,
                        c_date: student.c_date,
                        Rank: student.Rank,
                      });

                      // Update text area if winner certificate is selected
                      if (certificateType == 3) {
                        const year = getSelectedCompetitionYear();
                        const rankText = student.Rank ? `for ${getOrdinal(student.Rank)} position` : "Winner";
                        setTeaxtAreaValue(`${rankText} in PolyMatch ${selectedCompetitionName || ''} ${year}`);
                      }
                    } else {
                      setSelectedStudentDetails(null);
                    }
                  }}
                  styles={{
                    control: (base) => ({
                      ...base,
                      border: 'none',
                      boxShadow: 'none',
                      minHeight: '35px',
                      background: 'transparent'
                    }),
                    container: (base) => ({
                      ...base,
                      flex: 1
                    }),
                    menu: (base) => ({
                      ...base,
                      zIndex: 9999
                    })
                  }}
                />
              </td>
            </tr>
            <tr>
              <th>Parent Name</th>
              <td>{selectedStudentDetails?.parentname || 'N/A'}</td>
            </tr>
            <tr>
              <th>Event Name</th>
              <td><textarea rows={3} style={{ width: "100%", border: 'none', outline: 'none', background: 'transparent' }} value={textAreaValue} placeholder='Enter Event Name' onChange={(e) => setTeaxtAreaValue(e.target.value)} /></td>
            </tr>

            <tr>
              <th>Certificate Type</th>
              <td>
                <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                  <select value={certificateType} onChange={chageCertificateType} style={{ flex: 1, border: 'none', outline: 'none', background: 'transparent' }}>
                    <option value={2}>Participation Certificate</option>
                    <option value={3}>Winning Certificate</option>
                  </select>
                  {certificateType == 3 && (
                    <select
                      value={winnersLimit}
                      onChange={(e) => setWinnersLimit(Number(e.target.value))}
                      style={{
                        width: 'auto',
                        border: 'none',
                        borderLeft: '1px solid #ccc',
                        outline: 'none',
                        background: 'transparent',
                        paddingLeft: '10px',
                        fontWeight: 'bold',
                        color: '#03b4c6'
                      }}
                    >
                      {Array.from({ length: 20 }, (_, i) => i + 1).map(num => (
                        <option key={num} value={num}>Top {num}</option>
                      ))}
                    </select>
                  )}
                </div>
              </td>
            </tr>
          </tbody>
        </table>
      </div>

      {/* <div className='GenSalary'>
        <button onClick={() => generateCertificatePdf()}>Download Certificate </button>
      </div> */}
      <div className='GenSalary' style={{ flexDirection: 'column', alignItems: 'center', gap: '20px' }}>

        {/* Row 1: Primary Actions (Single Student) */}
        <div style={{ display: 'flex', gap: '20px', justifyContent: 'center', width: '100%' }}>
          <button
            className="download-single"
            onClick={downloadSingleCertificate}
            disabled={isGeneratingSingle || !selectedStudentDetails}
          >
            {isGeneratingSingle ? "Generating..." : "Download Certificate"}
          </button>

          <button
            onClick={() => emailSingleCertificate(selectedStudentDetails.id)}
            disabled={emailSingleLoading[selectedStudentDetails?.id] || !selectedStudentDetails}
            style={{
              backgroundColor: selectedStudentDetails ? "#4CAF50" : "#ccc",
              color: "white"
            }}
          >
            {emailSingleLoading[selectedStudentDetails?.id] ? "Sending Email..." : "Send Email"}
          </button>
        </div>

        {/* Row 2: Bulk / Admin Actions */}
        <div style={{ display: 'flex', gap: '20px', justifyContent: 'center', width: '100%', flexDirection: 'column', alignItems: 'center' }}>
          <div style={{ display: 'flex', gap: '20px', justifyContent: 'center', width: '100%' }}>
            {!isDownloadingAll ? (
              <button onClick={downloadAllCertificates}>Download All Certificates</button>
            ) : (
              <button
                onClick={handleStopDownload}
                style={{
                  backgroundColor: "#f44336",
                  color: "white"
                }}
              >
                Stop Download
              </button>
            )}
            <button onClick={emailAllCertificates} disabled={isDownloadingAll}>Sent mails to all </button>
          </div>

          {isDownloadingAll && (
            <div style={{ width: '100%', maxWidth: '500px', textAlign: 'center' }}>
              <div style={{ marginBottom: '5px', fontWeight: 'bold' }}>
                Progress: {downloadProgress.current} / {downloadProgress.total} Certificates
              </div>
              <div style={{
                width: '100%',
                height: '10px',
                backgroundColor: '#eee',
                borderRadius: '5px',
                overflow: 'hidden',
                border: '1px solid #ccc'
              }}>
                <div style={{
                  width: `${(downloadProgress.current / downloadProgress.total) * 100}%`,
                  height: '100%',
                  backgroundColor: '#03b4c6',
                  transition: 'width 0.3s ease'
                }}></div>
              </div>
            </div>
          )}
        </div>
      </div>

      <div style={{ padding: "3%" }}>
        {selectedStudentDetails && (
          <div
            style={{ width: "1600px", height: "1120px", position: "relative", margin: "0" }}
            ref={targetRef}
          >
            <img
              src={LebronStretch}
              style={{ height: "100%", width: "100%", objectFit: "cover" }}
            />

            <div
              style={{
                position: "absolute",
                top: "2.25%",
                right: "15%",
                width: "400px",
                textAlign: "right",
                fontWeight: "bold",
                fontSize: "15px",
                color: "purple",
                lineHeight: "1.1",
                whiteSpace: "normal",
                overflowWrap: "break-word",
                wordWrap: "break-word"
              }}
            >
              Certificate # {certificateNumber}
            </div>

            <div
              style={{
                position: "absolute",
                top: "40%",
                textAlign: "center",
                width: "100%",
                fontSize: "40px",
                color: "white",
                fontWeight: "bold"
              }}
            >
              {selectedStudentDetails.firstname?.toUpperCase()}{" "}
              {selectedStudentDetails?.lastname?.toUpperCase()}
            </div>

            <div
              style={{
                position: "absolute",
                top: "51%",
                padding: "0 15%",
                textAlign: "center",
                width: "100%",
                fontSize: "22px",
                color: "purple",
                fontWeight: "500"
              }}
            >
              {(() => {
                // Robust lookup for Age and Year to handle stale state
                const currentStudent = students.find(s => s.id === selectedStudentDetails?.id) || selectedStudentDetails;
                const currentAgeGroup = ageGroups.find(ag => ag.Agegroup_Id == currentStudent?.Agegroup_Id); // Use == for loose equality
                const displayAge = currentAgeGroup?.Display_Name || currentStudent?.reg_Age || currentStudent?.Age || selectedStudentDetails?.age || "";

                return certificateType ? (
                  <>
                    {" "}
                    S/D of <b>{selectedStudentDetails?.parentname}</b> {textAreaValue}
                    {displayAge && (
                      <>
                        <br />
                        <span>(Age Category {displayAge})</span>
                      </>
                    )}
                  </>
                ) : (
                  <>{textAreaValue}</>
                );
              })()}
            </div>

            <img
              src={cLogo}
              style={{
                height: "22%",
                width: "20%",
                position: "absolute",
                top: "56%",
                left: "50%",
                transform: "translateX(-50%)"
              }}
            />

            <div
              style={{
                position: "absolute",
                top: "81%",
                left: "62%",
                fontWeight: "500",
                fontSize: "24px",
                color: "purple"
              }}
            >
              {currentDate}
            </div>
            <img
              src={Signature}
              style={{
                height: "10%",
                width: "15%",
                position: "absolute",
                top: "77%",
                left: "25%"
              }}
            />
          </div>
        )}
      </div>

      <hr style={{ margin: "40px 0" }} />

      <div
        className="filter-group"
        style={{
          display: "flex",
          justifyContent: "flex-start",   // 🔹 start from left
          alignItems: "center",       // 🔹 vertically center
          gap: "30px",
          margin: "20px",
          flexWrap: "wrap"
        }}
      >
        {/* Search Bar */}
        <div style={{ display: "flex", flexDirection: "column" }}>
          <label>Search Students:</label>
          <input
            type="text"
            placeholder="Search by name, email, country..."
            value={searchTerm}
            onChange={handleSearchChange}
            style={{
              minWidth: "300px",
              padding: "8px",
              borderRadius: "4px",
              border: "1px solid #ccc",
              outline: "none"
            }}
          />
        </div>

        {/* Competition Filter */}
        <div style={{ display: "flex", flexDirection: "column" }}>
          <label>Competition Filter:</label>
          <select
            value={filterCompetition}
            onChange={handleCompetitionChangeFilter}
            style={{ minWidth: "220px", padding: "8px", borderRadius: "4px", border: "1px solid #ccc" }}
          >
            <option value="All">All Competitions</option>
            {competition?.map(c => (
              <option key={c.Competition_Id} value={c.Competition_Id}>
                {c.Competition_Name} ({new Date(c.Competition_date).getFullYear()})
              </option>
            ))}
          </select>
        </div>

        {/* Age Group Filter */}
        <div style={{ display: "flex", flexDirection: "column" }}>
          <label>Age Group Filter:</label>
          <select
            value={filterAgeGroup}
            onChange={handleAgeGroupChangeFilter}
            style={{ minWidth: "220px", padding: "8px", borderRadius: "4px", border: "1px solid #ccc" }}
          >
            <option value="All">All Age Groups</option>
            {filteredAgeGroups?.map(ag => (
              <option key={ag.Agegroup_Id} value={ag.Agegroup_Id}>
                {ag.Display_Name}
              </option>
            ))}
          </select>
        </div>

        {/* Excel Upload Button */}
        <div style={{ display: "flex", flexDirection: "column" }}>
          <label>Upload Excel:</label>
          <div style={{ display: "flex", alignItems: "center", gap: "10px" }}>
            <div style={{ position: 'relative' }}>
              <input
                type="file"
                ref={fileInputRef}
                style={{ display: 'none' }}
                accept=".xlsx, .xls"
                onChange={handleExcelUpload}
              />
              <button
                className="upload-excel"
                onClick={() => fileInputRef.current.click()}
                disabled={isUploading}
                style={{
                  minWidth: "220px",
                  padding: "8px",
                  backgroundColor: "#28a745",
                  color: "white",
                  border: "none",
                  borderRadius: "4px",
                  cursor: "pointer",
                  fontWeight: "bold",
                  border: "1px solid #28a745" // Match border width/style sort of
                }}
              >
                {isUploading ? "Uploading..." : "Upload Excel Results"}
              </button>
            </div>
            <button
              className="download-sample"
              onClick={downloadSampleExcel}
              style={{
                minWidth: "220px",
                padding: "8px",
                backgroundColor: "#03b4c6",
                color: "white",
                border: "none",
                borderRadius: "4px",
                cursor: "pointer",
                fontWeight: "bold"
              }}
            >
              Download Sample Format
            </button>
          </div>
        </div>
      </div>

      <div className="history-loading-section" style={{ textAlign: "center", margin: "20px" }}>
        {!showInvoices ? (
          <div className="load-invoices-box" style={{ padding: "40px", border: "1px dashed #ccc", borderRadius: "8px", backgroundColor: "#f9f9f9" }}>
            <h3>Certificate Generation History</h3>
            <p style={{ color: "rgb(102, 102, 102)", marginBottom: "20px" }}>View previously generated certificates and send emails.</p>
            <button
              onClick={handleLoadAll}
              style={{
                padding: "12px 24px",
                backgroundColor: "rgb(3, 180, 198)",
                color: "white",
                border: "none",
                borderRadius: "5px",
                cursor: "pointer",
                fontWeight: "bold"
              }}
            >
              Load All Certificates
            </button>
          </div>
        ) : (
          <div className="load-action-row" style={{ display: "flex", justifyContent: "flex-end", margin: "20px" }}>
            <button
              onClick={handleCloseInvoices}
              style={{
                padding: "10px 20px",
                backgroundColor: "rgb(244, 67, 54)",
                color: "white",
                border: "none",
                borderRadius: "5px",
                cursor: "pointer",
                fontWeight: "bold"
              }}
            >
              Close History
            </button>
          </div>
        )}
      </div>

      {showInvoices && (
        <>
          {/* Controls: search, filters */}

          <div className="invoices-table-container">
            {loading ? (
              <div className="loading-spinner">
                <div className="spinner"></div>
                <p>Loading invoices...</p>
              </div>
            ) : (
              <div className="table-wrapper">
                <div class="table-responsive">
                  <table className="invoices-table">
                    <thead>
                      <tr>
                        <th>Medal</th>
                        <th>Student Name</th>
                        <th>Username</th>
                        <th>Competition Name</th>
                        <th>Whatsapp_number</th>
                        <th>Age</th>
                        <th>Country</th>
                        <th>Email</th>
                        <th>Parent Name</th>
                        <th>Total</th>
                        <th>C ans</th>
                        <th>In Correct ans</th>
                        <th>Rank</th>
                        <th>Certificate path</th>
                        <th>Actions</th>
                      </tr>
                    </thead>
                    <tbody>
                      {filteredInvoices.length > 0 ? (
                        filteredInvoices.map((invoice, index) => (
                          <tr key={index}>
                            <td>{getRankIcon(invoice?.Rank)}</td>
                            <td>{highlightText(`${invoice.First_name} ${invoice.Last_name}`, searchTerm)}</td>
                            <td>{highlightText(invoice.Username, searchTerm)}</td>
                            <td>
                              {highlightText(
                                competition?.find(c =>
                                  c.Competition_Id === invoice.Competition_Id
                                )?.Competition_Name || "N/A",
                                searchTerm
                              )}
                            </td>
                            <td>{highlightText(invoice.Contact_Num, searchTerm)}</td>
                            <td>{highlightText(invoice?.reg_Age || invoice?.Age, searchTerm)}</td>
                            <td>{highlightText(invoice.Country, searchTerm)}</td>
                            <td>{highlightText(invoice.Email, searchTerm)}</td>
                            <td>{highlightText(invoice.Parent_name, searchTerm)}</td>
                            <td>{highlightText(invoice.Total, searchTerm)}</td>
                            <td>{highlightText(invoice.C_ans, searchTerm)}</td>
                            <td>{highlightText(invoice.Incorrect_ans, searchTerm)}</td>
                            <td>
                              {highlightText(invoice?.Rank, searchTerm)}
                            </td>
                            <td>
                              {invoice.Certificate_Path ? (
                                <button
                                  onClick={() => {
                                    fetch(`${(process.env.REACT_APP_API_BASE_URL || process.env.REACT_APP_LOCAL_SERVER_API)}/${invoice.Certificate_Path}`)
                                      .then(response => {
                                        if (!response.ok) {
                                          alert('No Certificate Available');
                                          throw new Error('Certificate not found');
                                        }
                                        return response.blob();
                                      })
                                      .then(blob => {
                                        const url = window.URL.createObjectURL(blob);
                                        const link = document.createElement('a');
                                        link.href = url;
                                        // Extract filename from path
                                        const filename = invoice.Certificate_Path.split('/').pop();
                                        link.download = filename;
                                        document.body.appendChild(link);
                                        link.click();
                                        document.body.removeChild(link);
                                        window.URL.revokeObjectURL(url);
                                      })
                                      .catch(error => {
                                        console.error('Download error:', error);
                                        // You can also show an alert or toast notification here
                                      });
                                  }}
                                  style={{
                                    padding: '8px 16px',
                                    backgroundColor: '#4CAF50',
                                    color: 'white',
                                    border: 'none',
                                    borderRadius: '4px',
                                    cursor: 'pointer'
                                  }}
                                >
                                  Download
                                </button>
                              ) : (
                                'No Certificate'
                              )}
                            </td>
                            <td>
                              <button
                                onClick={() => emailSingleCertificate(invoice.Result_Id || invoice.id)}
                                disabled={emailSingleLoading[invoice.Result_Id || invoice.id] || !invoice.Certificate_Path}
                                style={{
                                  padding: "5px 10px",
                                  backgroundColor: invoice.Certificate_Path ? "#03b4c6" : "#ccc",
                                  color: "white",
                                  border: "none",
                                  borderRadius: "4px",
                                  cursor: invoice.Certificate_Path ? "pointer" : "not-allowed",
                                  fontSize: "12px"
                                }}
                              >
                                {emailSingleLoading[invoice.Result_Id || invoice.id] ? "Sending..." : "Send Email"}
                              </button>
                            </td>
                          </tr>
                        ))
                      ) : (
                        <tr>
                          <td colSpan="15" className="no-data">
                            {filterCompetition !== "All" ? "Result not found" : "No Results Found"}
                          </td>
                        </tr>
                      )}
                    </tbody>
                  </table>
                </div>
              </div>
            )}
            <br />
          </div>
        </>
      )}

      <Footer />
      <ToastContainer />
    </>
  );
};

export default CreateCertificate2;